<script setup>
import { computed } from 'vue';

const props = defineProps({
  label: { type: String, default: '' },
  bg: { type: String, default: 'bg-n-slate-3' },
  text: { type: String, default: 'text-n-slate-11' },
  dot: { type: String, default: '' },
  ring: { type: String, default: '' },
});

const hasLabel = computed(() => !!props.label);
</script>

<template>
  <span
    v-if="hasLabel"
    class="inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-[11px] font-semibold"
    :class="[bg, text, ring]"
  >
    <span v-if="dot" class="w-1.5 h-1.5 rounded-full shrink-0" :class="dot" />
    {{ label }}
  </span>
  <span v-else class="text-xs font-medium text-n-slate-12">—</span>
</template>
